var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"common-layout"},[_c('el-container',[_c('el-header',{style:({ background:'transparent'})},[_c('Header',{staticClass:"navbar-container"})],1),_c('div',{staticClass:"content-container css-gradient"},[_c('el-main',{staticClass:"main-container"},[_c('Main')],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }